import { Alert } from 'src/design/atoms/Alert';
import { IconAlertCircle } from '@tabler/icons-react';
import React, { useMemo } from 'react';
import { getErrorMessage } from 'src/utils';
import { Header } from 'src/design/organisms/Header';
import { WorkflowStatusPanel } from 'src/design/molecules/WorkflowStatusPanel';
import { useWorkflowStatusFilters } from 'src/app/workflows/useWorkflowStatusFilters';
import { useWorkflowStatusSegments } from 'src/app/workflows/useWorkflowStatusSegments';
import { mergeWorkflowSteps } from 'src/app/workflows/mergeWorkflowSteps';
import { RFI_STATUS_COLORS } from 'src/app/rfis/rfiStatusColors';
import { useRfisOverview } from 'src/api/queries/rfis/useRfisOverview';
import { RfisOverviewTable } from './components/RfisOverviewTable';

export const RFIs: React.FC = () => {
  const { data, isLoading, error } = useRfisOverview();
  const rfis = useMemo(() => data ?? [], [data]);

  const mergedWorkflow = useMemo(() => mergeWorkflowSteps(rfis), [rfis]);

  const { filters, covered, statusFilter, setStatusFilter, filteredItems } =
    useWorkflowStatusFilters(
      rfis,
      mergedWorkflow,
      Object.keys(RFI_STATUS_COLORS),
    );
  const segments = useWorkflowStatusSegments(
    rfis,
    filters,
    covered,
    mergedWorkflow,
    RFI_STATUS_COLORS,
  );

  return (
    <>
      <Header
        title="RFIs"
        breadcrumbProps={{ items: [{ text: 'RFIs' }] }}
        helpText="View RFIs across all jobs you have access to. Select an RFI to open it in its job."
      />

      {error && (
        <Alert
          icon={<IconAlertCircle size={16} />}
          title="Error"
          color="red"
          mb="md"
        >
          {getErrorMessage(error)}
        </Alert>
      )}

      <WorkflowStatusPanel
        segments={segments}
        value={statusFilter}
        onChange={setStatusFilter}
      />

      <RfisOverviewTable rfis={filteredItems} loading={isLoading} />
    </>
  );
};
